module.exports = __webpack_public_path__ + "img/diagram-square.c9891cb9.svg";